import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import baseTheme from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface HeaderActionsSearchStyles {
    container: InjectableCss;
    cartSignInMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    signInCartContainer?: GridContainerProps;
    signInGridItemContainer?: GridItemProps;
    cartGridItemContainer?: GridItemProps;
    searchContainer: InjectableCss;
    parentContainer: InjectableCss;
}

export const HeaderActionsSearchStyles: HeaderActionsSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: flex-start;
            margin: 0 auto;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        max-width: ${maxWidths[1]}px;
                    `,
                    css`
                        max-width: ${maxWidths[1]}px;
                    `,
                    css`
                        max-width: ${maxWidths[2]}px;
                    `,
                    css`
                        max-width: ${maxWidths[3]}px;
                    `,
                    css`
                        max-width: ${maxWidths[4]}px;
                    `,
                ]);
            }}
            padding: 10px 10px 10px 10px;
            flex-wrap: nowrap;
            align-items: center;
        `,
    },
    cartSignInMenuWrapper: {
        css: css`
            min-width: 268px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex: 0 0 auto;
            padding: 0 0 0 25px;
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    signInCartContainer: {
        css: css`
            & ${GridOffset} {
                width: 100%;
                margin: 0;
                justify-content: flex-end;
            }
        `,
    },
    signInGridItemContainer: {
        width: 6,
        css: css`
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            padding-right: 0;
            text-align: end;
            align-items: center;
            > div:first-child {
                display: flex;
            }
        `,
    },

    cartGridItemContainer: {
        width: 6,
        css: css`
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            padding-left: 25px;
            padding-right: 0;
            text-align: end;
        `,
    },
    searchContainer: {
        css: css`
            flex: 1 1 auto;
        `,
    },
    parentContainer: {
        css: css`
            background-color: ${getColor("secondary.main")};
        `,
    },
};

const HeaderActionsSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...HeaderActionsSearchStyles.parentContainer}>
        <StyledWrapper {...HeaderActionsSearchStyles.container}>
            <StyledWrapper {...HeaderActionsSearchStyles.searchContainer}>
                <Zone contentId={id} zoneName="SearchFix" />
            </StyledWrapper>
            <StyledWrapper {...HeaderActionsSearchStyles.cartSignInMenuWrapper}>
                <StyledWrapper {...HeaderActionsSearchStyles.signInGridItemContainer}>
                    <Zone contentId={id} zoneName="SignIn" />
                </StyledWrapper>
                <StyledWrapper {...HeaderActionsSearchStyles.cartGridItemContainer}>
                    <Zone contentId={id} zoneName="Cart" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const headerActionsSearch: WidgetModule = {
    component: HeaderActionsSearch,
    definition: {
        group: "Header",
        icon: "Filter",
        fieldDefinitions: [],
        displayName: "Header Actions and Search",
    },
};

export default headerActionsSearch;
